import React from 'react';

import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import { ErrorMessage } from '@atlaskit/form/error-message';
import { MessageWrapper } from '@atlaskit/form/message-wrapper';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import {
	useFieldCustomError,
	useFieldValidationErrors,
} from '../../../../../../../controllers/form-renderer-store';

const styles = cssMap({
	errorMessage: {
		font: token('font.heading.xxsmall'),
		fontWeight: token('font.weight.regular'),
		color: token('color.text.danger'),
	},
	errorPlaceholder: {
		height: '18px',
	},
});

export const FormFieldErrorRenderer = ({
	fieldId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFieldCustomError, useFieldValidationErrors);
	const fieldCustomError = useFieldCustomError({ fieldId });
	const fieldValidationErrors = useFieldValidationErrors({ fieldId });

	const errorMessage = [
		...fieldValidationErrors.map((error) => error.errorMessage),
		...(fieldCustomError ? [fieldCustomError] : []),
	].join(' ');

	return errorMessage.length > 0 ? (
		<Box testId={`field-${fieldId}-error-renderer`}>
			<MessageWrapper>
				<ErrorMessage>
					<Box
						xcss={styles.errorMessage}
						id={fg('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined}
					>
						{errorMessage}
					</Box>
				</ErrorMessage>
			</MessageWrapper>
		</Box>
	) : (
		<Box xcss={styles.errorPlaceholder} />
	);
};
